var _path, _ellipse, _circle, _circle2, _ellipse2, _ellipse3, _path2, _path3, _circle3, _circle4, _circle5, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResultsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 120,
    viewBox: "0 0 186 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 97C115.552 97 116 96.5523 116 96C116 95.4477 115.552 95 115 95V97ZM161 49C161 49.5523 161.448 50 162 50C162.552 50 163 49.5523 163 49H161ZM28 1H158V-1H28V1ZM25 92V4H23V92H25ZM115 95H28V97H115V95ZM161 4V49H163V4H161ZM23 92C23 94.7614 25.2386 97 28 97V95C26.3431 95 25 93.6569 25 92H23ZM158 1C159.657 1 161 2.34315 161 4H163C163 1.23858 160.761 -1 158 -1V1ZM28 -1C25.2386 -1 23 1.23858 23 4H25C25 2.34315 26.3431 1 28 1V-1Z",
    fill: "#053668"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 92,
    cy: 100,
    rx: 82,
    ry: 4,
    fill: "#053668"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 46.5,
    r: 4.5,
    fill: "#053668"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 46.5,
    r: 4.5,
    fill: "#053668"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 70.5,
    cy: 55.5,
    rx: 5.5,
    ry: 2.5,
    fill: "#053668"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 115.5,
    cy: 55.5,
    rx: 5.5,
    ry: 2.5,
    fill: "#053668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 62C99 59 96.3137 57 93 57C89.6863 57 87 59 86 62",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3C24 1.34315 25.3431 0 27 0H159C160.657 0 162 1.34315 162 3V9H24V3Z",
    fill: "#053668"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 4,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 4,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 4,
    r: 2,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.213 61.7868C181.929 73.5025 181.929 92.4975 170.213 104.213C158.497 115.929 139.502 115.929 127.787 104.213C116.071 92.4975 116.071 73.5025 127.787 61.7868C139.502 50.0711 158.497 50.0711 170.213 61.7868Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.213 104.213C181.929 92.4975 181.929 73.5025 170.213 61.7868C158.497 50.0711 139.502 50.0711 127.787 61.7868C116.071 73.5025 116.071 92.4975 127.787 104.213C139.502 115.929 158.497 115.929 170.213 104.213ZM170.213 104.213L183 117",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129 99H161C163.209 99 165 97.2091 165 95V63",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsIcon);
export default __webpack_public_path__ + "static/media/no-results-icon.0de03db3.svg";
export { ForwardRef as ReactComponent };